import { assign, DoneActorEvent, fromPromise, sendTo, setup } from 'xstate';
import { showAxiosErrorAction } from '~/features/actions';
import { MsaasDetail } from '~/types/hlx/msaasDetail';
import { resetLoading, setLoading } from './actions';
import { API_CALLS } from './api';
import { Context, Events, OnAddEvent, OnUpdateEvent } from './types';

export const laborMetricsMachine = setup({
  types: {
    context: {} as Context,
    events: {} as Events,
    input: {} as Partial<Context>,
  },
  actors: {
    createLaborMetrics: fromPromise(API_CALLS.create),
    updateLaborMetrics: fromPromise(API_CALLS.patch),
  },
  actions: {
    sendError: showAxiosErrorAction,
    setLoading: assign(setLoading),
    resetLoading: assign(resetLoading),
    addMsaasDetail: sendTo(
      ({ context }) => {
        const parentRef = context.parentRef;
        if (!parentRef) {
          throw new Error('parentRef is required in laborMetricsMachine');
        }
        return parentRef;
      },
      ({ event }) => ({
        type: 'ON_ADD_DETAIL',
        payload: { output: (event as unknown as DoneActorEvent<MsaasDetail>).output },
      })
    ),
    updateMsaasDetail: sendTo(
      ({ context }) => {
        const parentRef = context.parentRef;
        if (!parentRef) {
          throw new Error('parentRef is required in laborMetricsMachine');
        }
        return parentRef;
      },
      ({ event }) => ({
        type: 'ON_UPDATE_DETAIL',
        payload: { output: (event as unknown as DoneActorEvent<MsaasDetail>).output },
      })
    ),
  },
}).createMachine({
  context: ({ input }) => ({
    loading: false,
    parentRef: input?.parentRef,
  }),
  initial: '$_VIEW',
  states: {
    $_VIEW: {
      on: {
        ON_ADD: {
          target: '$_SEND_CREATE',
          actions: 'setLoading',
        },
        ON_UPDATE: {
          target: '$_SEND_UPDATE',
          actions: 'setLoading',
        },
      },
    },
    $_SEND_CREATE: {
      invoke: {
        id: 'createLaborMetrics',
        src: 'createLaborMetrics',
        input: ({ context, event }) =>
          ({ context, event }) as { context: Context; event: OnAddEvent },
        onDone: {
          target: '$_VIEW',
          actions: ['resetLoading', 'addMsaasDetail'],
        },
        onError: {
          target: '$_VIEW',
          actions: ['sendError', 'resetLoading'],
        },
      },
    },
    $_SEND_UPDATE: {
      invoke: {
        id: 'updateLaborMetrics',
        src: 'updateLaborMetrics',
        input: ({ context, event }) =>
          ({ context, event }) as { context: Context; event: OnUpdateEvent },
        onDone: {
          target: '$_VIEW',
          actions: ['resetLoading', 'updateMsaasDetail'],
        },
        onError: {
          target: '$_VIEW',
          actions: ['sendError', 'resetLoading'],
        },
      },
    },
  },
});
